export type CalendarEventColor =
  | "blue"
  | "green"
  | "red"
  | "orange"
  | "purple"
  | "yellow"
  | "pink"
  | "teal";

export interface CalendarEvent {
  id: string;
  title: string;
  description?: string;
  /** ISO date YYYY-MM-DD */
  startDate: string;
  /** ISO date YYYY-MM-DD */
  endDate: string;
  /** HH:mm */
  startTime: string;
  /** HH:mm */
  endTime: string;
  color: CalendarEventColor;
}

export const EVENT_COLORS: { id: CalendarEventColor; label: string; hex: string }[] = [
  { id: "blue", label: "Azul", hex: "#2F5BE0" },
  { id: "green", label: "Verde", hex: "#0F9D70" },
  { id: "red", label: "Vermelho", hex: "#E2574C" },
  { id: "orange", label: "Laranja", hex: "#F59E0B" },
  { id: "purple", label: "Roxo", hex: "#8B5CF6" },
  { id: "yellow", label: "Amarelo", hex: "#EAB308" },
  { id: "pink", label: "Rosa", hex: "#EC4899" },
  { id: "teal", label: "Turquesa", hex: "#14B8A6" },
];

export function colorHex(c: CalendarEventColor): string {
  return EVENT_COLORS.find((x) => x.id === c)?.hex ?? "#2F5BE0";
}